import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "text-center pt-2" }
const _hoisted_2 = { class: "input-group search-container" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { class: "input-group-append" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search font-size-sm" }, null, -1 /* HOISTED */)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "me-0 ms-lg-4" }
const _hoisted_8 = { class: "me-auto ms-lg-4" }
const _hoisted_9 = { class: "btn-group" }
const _hoisted_10 = {
  key: 0,
  class: "btn-group"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-sm btn-primary ms-lg-2 dropdown-toggle",
  "data-bs-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false",
  "aria-controls": "newInquiryDropdown"
}, " New ", -1 /* HOISTED */)
const _hoisted_12 = {
  class: "dropdown-menu",
  id: "newInquiryDropdown"
}
const _hoisted_13 = { class: "h-100 d-flex flex-column mb-3 mt-2" }
const _hoisted_14 = { class: "table table-responsive-md border border-gray" }
const _hoisted_15 = { class: "bg-table-header table-header" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Inquiry Date")
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { key: 2 }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Patient Information")
const _hoisted_21 = { class: "fas fa-question-circle ms-1" }
const _hoisted_22 = { key: 3 }
const _hoisted_23 = { key: 4 }
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Contact Information")
const _hoisted_25 = { class: "fas fa-question-circle ms-1" }
const _hoisted_26 = { key: 5 }
const _hoisted_27 = { key: 6 }
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" Branch ")
const _hoisted_29 = { key: 7 }
const _hoisted_30 = { key: 8 }
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" Service Requested ")
const _hoisted_32 = { key: 9 }
const _hoisted_33 = { key: 10 }
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" Assigned Team Member ")
const _hoisted_35 = { key: 11 }
const _hoisted_36 = { key: 12 }
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" Follow-Up Date ")
const _hoisted_38 = { key: 13 }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Comment", -1 /* HOISTED */)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("th", { class: "text-end" }, "Actions", -1 /* HOISTED */)
const _hoisted_41 = {
  key: 0,
  class: "table-empty"
}
const _hoisted_42 = ["colspan"]
const _hoisted_43 = /*#__PURE__*/_createElementVNode("h3", null, "No Inquiries/Leads Found.", -1 /* HOISTED */)
const _hoisted_44 = [
  _hoisted_43
]
const _hoisted_45 = {
  key: 1,
  class: "table-error"
}
const _hoisted_46 = ["colspan"]
const _hoisted_47 = /*#__PURE__*/_createElementVNode("span", { class: "shimmer-loading" }, null, -1 /* HOISTED */)
const _hoisted_48 = [
  _hoisted_47
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InquiryForm = _resolveComponent("InquiryForm")!
  const _component_InquiryFormHomecareHomehealth = _resolveComponent("InquiryFormHomecareHomehealth")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_BranchDefaultFilter = _resolveComponent("BranchDefaultFilter")!
  const _component_SortableTh = _resolveComponent("SortableTh")!
  const _component_ErrorMessageHandler = _resolveComponent("ErrorMessageHandler")!
  const _component_CentralInquiryRow = _resolveComponent("CentralInquiryRow")!
  const _component_StaticTableFormater = _resolveComponent("StaticTableFormater")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_ListLayout = _resolveComponent("ListLayout")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_ListLayout, {
    "form-title": "Add Inquiry",
    "show-form": _ctx.isAddItemRequested,
    "has-list-scroll": true
  }, {
    "list-form": _withCtx(() => [
      (_ctx.isAddItemRequested && !_ctx.isApplicationHomeCare && !_ctx.isApplicationHomeHealth)
        ? (_openBlock(), _createBlock(_component_InquiryForm, {
            key: 0,
            inquiry: _ctx.newInquiry,
            isLoading: _ctx.isSaveNewInProgress,
            serviceTypeEnums: _ctx.serviceTypeEnums,
            branches: _ctx.currentAddBranches,
            onUpdateBranch: _ctx.updateAddBranch,
            ref: "inquiryForm"
          }, null, 8 /* PROPS */, ["inquiry", "isLoading", "serviceTypeEnums", "branches", "onUpdateBranch"]))
        : _createCommentVNode("v-if", true),
      (_ctx.isAddItemRequested && (_ctx.isApplicationHomeCare || _ctx.isApplicationHomeHealth))
        ? (_openBlock(), _createBlock(_component_InquiryFormHomecareHomehealth, {
            key: 1,
            inquiry: _ctx.newInquiry,
            isLoading: _ctx.isSaveNewInProgress,
            branches: _ctx.currentAddBranches,
            onUpdateBranch: _ctx.updateAddBranch,
            ref: "homecareInquiryForm"
          }, null, 8 /* PROPS */, ["inquiry", "isLoading", "branches", "onUpdateBranch"]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary btn-md",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.saveNewInquiry()))
        }, "Add Inquiry"),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-outline-secondary btn-md ms-2",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeAddInquiry(_ctx.hospiceApplicationId)))
        }, " Cancel ")
      ])
    ]),
    "list-header": _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createElementVNode("input", {
          disabled: _ctx.isLoading,
          type: "text",
          class: "form-control border-end-0",
          placeholder: "Search Inquiries by Patient Name",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.term) = $event))
        }, null, 8 /* PROPS */, _hoisted_3), [
          [_vModelText, _ctx.term]
        ]),
        _createElementVNode("span", _hoisted_4, [
          _createElementVNode("div", {
            class: "input-group-text bg-transparent p-2",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.search()))
          }, _hoisted_6)
        ])
      ])
    ]),
    "list-header-drop": _withCtx(() => [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_MultiSelect, {
          "drop-down-options": _ctx.agencyMultiSelectOptions,
          "selected-options": _ctx.selectedAgencies,
          onUpdateBranches: _ctx.updateBranchesbyAgency,
          "label-text": "Organizations"
        }, null, 8 /* PROPS */, ["drop-down-options", "selected-options", "onUpdateBranches"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_BranchDefaultFilter, {
          "check-all-by-default": true,
          "selected-branches": _ctx.selectedBranches,
          onUpdateBranches: _ctx.updateBranches,
          "selected-agencies-name": _ctx.selectedAgenciesName,
          "is-inquiry": true
        }, null, 8 /* PROPS */, ["selected-branches", "onUpdateBranches", "selected-agencies-name"])
      ])
    ]),
    "list-header-new": _withCtx(() => [
      _createElementVNode("div", _hoisted_9, [
        (_ctx.excelExportPermission)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "btn btn-sm btn-primary ms-lg-2",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.downloadChart()))
            }, " Export to Excel "))
          : _createCommentVNode("v-if", true)
      ]),
      (
                    !_ctx.isAddItemRequested &&
                    (_ctx.canAddHospiceInquiry ||
                        _ctx.canAddPalliativeInquiry ||
                        _ctx.canAddHomeCareInquiry ||
                        _ctx.canAddHomeHealthInquiry)
                )
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              (_ctx.canAddHospiceInquiry)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    class: "dropdown-item",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openAddInquiry(_ctx.hospiceApplicationId)))
                  }, "Axxess Hospice"))
                : _createCommentVNode("v-if", true),
              (_ctx.canAddPalliativeInquiry)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    class: "dropdown-item",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.openAddInquiry(_ctx.palliativeApplicationId)))
                  }, "Axxess Palliative Care"))
                : _createCommentVNode("v-if", true),
              (_ctx.canAddHomeCareInquiry)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 2,
                    class: "dropdown-item",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.openAddInquiry(_ctx.homeCareApplicationId)))
                  }, "Axxess Home Care"))
                : _createCommentVNode("v-if", true),
              (_ctx.canAddHomeHealthInquiry)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 3,
                    class: "dropdown-item",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.openAddInquiry(_ctx.homeHealthApplicationId)))
                  }, "Axxess Home Health"))
                : _createCommentVNode("v-if", true)
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_Pagination, {
          ref: "paginationInstance",
          pageChanged: _ctx.pageChangedCallback,
          isLoading: _ctx.isLoading,
          entity: "Inquiries",
          showPageSizeOptions: true,
          classes: "pagination-footer",
          pageSize: _ctx.pageSize,
          onUpdatePageSizeChanged: _ctx.updatePageSizeChanged
        }, {
          default: _withCtx(() => [
            _createVNode(_component_StaticTableFormater, {
              enabled: true,
              isLoading: !(!_ctx.isLoading && _ctx.hasData),
              backColumnCount: 1,
              frontColumnCount: 4,
              tableColumnSettings: _ctx.getCustomSettings(),
              columnsAltered: _ctx.dynamicTableToggled,
              columns: _ctx.columns,
              "onUpdate:columns": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.columns) = $event))
            }, {
              default: _withCtx(() => [
                _createElementVNode("table", _hoisted_14, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", _hoisted_15, [
                      (_ctx.hasData)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_16, [
                            _createVNode(_component_SortableTh, {
                              "sort-by": _ctx.sortBy,
                              onSortByUpdated: _ctx.sortByUpdated,
                              "sort-order": _ctx.sortOrder,
                              onSortOrderUpdated: _ctx.sortOrderUpdated,
                              "sort-string": "date"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_17
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                          ]))
                        : (_openBlock(), _createElementBlock("th", _hoisted_18, "Inquiry/Lead Date")),
                      (_ctx.hasData)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_19, [
                            _createVNode(_component_SortableTh, {
                              "sort-by": _ctx.sortBy,
                              onSortByUpdated: _ctx.sortByUpdated,
                              "sort-order": _ctx.sortOrder,
                              onSortOrderUpdated: _ctx.sortOrderUpdated,
                              "sort-string": "lastName"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_20,
                                _withDirectives(_createElementVNode("i", _hoisted_21, null, 512 /* NEED_PATCH */), [
                                  [_directive_tooltip, { title: `Sort by Patient Name` }]
                                ])
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                          ]))
                        : (_openBlock(), _createElementBlock("th", _hoisted_22, "Patient Information")),
                      (_ctx.hasData)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_23, [
                            _createVNode(_component_SortableTh, {
                              "sort-by": _ctx.sortBy,
                              onSortByUpdated: _ctx.sortByUpdated,
                              "sort-order": _ctx.sortOrder,
                              onSortOrderUpdated: _ctx.sortOrderUpdated,
                              "sort-string": "contactLastName"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_24,
                                _withDirectives(_createElementVNode("i", _hoisted_25, null, 512 /* NEED_PATCH */), [
                                  [_directive_tooltip, { title: `Sort by Contact Name` }]
                                ])
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                          ]))
                        : (_openBlock(), _createElementBlock("th", _hoisted_26, "Contact Information")),
                      (_ctx.hasData)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_27, [
                            _createVNode(_component_SortableTh, {
                              "sort-by": _ctx.sortBy,
                              onSortByUpdated: _ctx.sortByUpdated,
                              "sort-order": _ctx.sortOrder,
                              onSortOrderUpdated: _ctx.sortOrderUpdated,
                              "sort-string": "branchName"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_28
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                          ]))
                        : (_openBlock(), _createElementBlock("th", _hoisted_29, "Branch")),
                      (_ctx.hasData)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_30, [
                            _createVNode(_component_SortableTh, {
                              "sort-by": _ctx.sortBy,
                              onSortByUpdated: _ctx.sortByUpdated,
                              "sort-order": _ctx.sortOrder,
                              onSortOrderUpdated: _ctx.sortOrderUpdated,
                              "sort-string": "servicesRequested"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_31
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                          ]))
                        : (_openBlock(), _createElementBlock("th", _hoisted_32, "Service Requested")),
                      (_ctx.hasData)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_33, [
                            _createVNode(_component_SortableTh, {
                              "sort-by": _ctx.sortBy,
                              onSortByUpdated: _ctx.sortByUpdated,
                              "sort-order": _ctx.sortOrder,
                              onSortOrderUpdated: _ctx.sortOrderUpdated,
                              "sort-string": "assignedUser"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_34
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                          ]))
                        : (_openBlock(), _createElementBlock("th", _hoisted_35, "Assigned Team Member")),
                      (_ctx.hasData)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_36, [
                            _createVNode(_component_SortableTh, {
                              "sort-by": _ctx.sortBy,
                              onSortByUpdated: _ctx.sortByUpdated,
                              "sort-order": _ctx.sortOrder,
                              onSortOrderUpdated: _ctx.sortOrderUpdated,
                              "sort-string": "followUpDate"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_37
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                          ]))
                        : (_openBlock(), _createElementBlock("th", _hoisted_38, "Follow-Up Date")),
                      _hoisted_39,
                      _hoisted_40
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    _createCommentVNode(" EMPTY "),
                    (!_ctx.isLoading && !_ctx.isError && !_ctx.hasData && !_ctx.branchRef?.isRequestPending)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_41, [
                          _createElementVNode("td", { colspan: _ctx.columns }, _hoisted_44, 8 /* PROPS */, _hoisted_42)
                        ]))
                      : _createCommentVNode("v-if", true),
                    _createCommentVNode(" ERROR "),
                    (!_ctx.isLoading && _ctx.isError && !_ctx.branchRef?.isRequestPending)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_45, [
                          _createElementVNode("td", { colspan: _ctx.columns }, [
                            _createVNode(_component_ErrorMessageHandler, {
                              title: "Inquiry list",
                              "show-try-again": true,
                              "try-again": _ctx.reset
                            }, null, 8 /* PROPS */, ["try-again"])
                          ], 8 /* PROPS */, _hoisted_46)
                        ]))
                      : _createCommentVNode("v-if", true),
                    _createCommentVNode(" LOADING "),
                    (_ctx.isLoading || _ctx.branchRef?.isRequestPending)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.loadingCount, (i) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            class: "table-loading",
                            key: `count-${i}`
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (i) => {
                              return (_openBlock(), _createElementBlock("td", {
                                key: `column-${i}`
                              }, _hoisted_48))
                            }), 128 /* KEYED_FRAGMENT */))
                          ]))
                        }), 128 /* KEYED_FRAGMENT */))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _createCommentVNode(" LIST "),
                  (!_ctx.isLoading && !_ctx.isError && _ctx.hasData && !_ctx.branchRef?.isRequestPending)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.page.items, (inquiry) => {
                        return (_openBlock(), _createElementBlock("tbody", {
                          key: inquiry.id
                        }, [
                          _createVNode(_component_CentralInquiryRow, {
                            lineOfServiceEnumMap: _ctx.lineOfServiceEnumMap,
                            inquiry: inquiry,
                            columns: _ctx.columns,
                            resetList: _ctx.reset,
                            referralsAddable: _ctx.referralsAddable,
                            serviceTypeEnums: _ctx.serviceTypeEnums,
                            branches: _ctx.currentEditBranches,
                            isEditSaveInProgress: _ctx.isEditSaveInProgress,
                            "onUpdate:isEditSaveInProgress": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.isEditSaveInProgress) = $event)),
                            onUpdateBranch: _ctx.updateEditBranch
                          }, null, 8 /* PROPS */, ["lineOfServiceEnumMap", "inquiry", "columns", "resetList", "referralsAddable", "serviceTypeEnums", "branches", "isEditSaveInProgress", "onUpdateBranch"])
                        ]))
                      }), 128 /* KEYED_FRAGMENT */))
                    : _createCommentVNode("v-if", true)
                ])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["isLoading", "tableColumnSettings", "columnsAltered", "columns"])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["pageChanged", "isLoading", "pageSize", "onUpdatePageSizeChanged"])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["show-form"]))
}